import type { AppProps } from 'next/app'
import { useRouter } from 'next/router'

import ClientErrorBoundary from '@/components/common/client-error-boundary'

type AppPageRendererProps = Pick<AppProps, 'Component' | 'pageProps'>

export default function AppPageRenderer({ Component, pageProps }: AppPageRendererProps) {
  const router = useRouter()
  // Key on the path only: query-string updates (search, filters, pagination) must not
  // remount the page, otherwise focused inputs lose their caret on every keystroke.
  const pathKey = router.asPath.split(/[?#]/)[0]

  return (
    <ClientErrorBoundary key={pathKey}>
      <Component {...pageProps} key={`${router.route}:${pathKey}`} />
    </ClientErrorBoundary>
  )
}
